import { z } from "zod";
import { channelWidgetSchema } from "./channel-widget-types.js";
import { widgetResultSchema } from "./widget-results.js";
/*
 * What the tenant found for one widget of a canvas, for one reader: the data an assembled canvas
 * carries beside its markup (canvas-widgets.ts), which the app draws with the shared blocks. A public
 * link carries the same thing, frozen as its publisher saw it.
 */
/** A field of the widget's data set that one of its figures is read in or grouped by: its name and how its amounts read. */
export const canvasWidgetFieldSchema = z.object({
    key: z.string().min(1).max(200),
    label: z.string().max(200),
    type: z.string().min(1).max(60),
    config: z.record(z.string(), z.unknown()).default({}),
});
export const canvasWidgetFillSchema = z.object({
    /**
     * The widget as published. Left out for a reader who may not open its channel, and for a widget that
     * is gone: such a reader is told nothing of it, not even its name.
     */
    widget: channelWidgetSchema.optional(),
    /**
     * The channel the widget is kept in, told as its widget is: what an open canvas listens to, so its
     * figures are read again when a record there changes.
     */
    channelId: z.string().min(1).max(64).optional(),
    fields: z.array(canvasWidgetFieldSchema).max(60).default([]),
    /**
     * Where a chart is grouped by a reference field, what the records it names are called, by record id:
     * told only for records kept in a channel this reader may open, as that channel would name them.
     */
    names: z.record(z.string().max(200), z.string().max(300)).default({}),
    /** What its evaluation gave this reader: a value, or which of the other states it is in. */
    result: widgetResultSchema(z.unknown()),
});
